import {
  EntityTabSubMenuSubTabs,
  getEntityTabRequestsSubTabCount,
} from '../../../EntityTab'
import { REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_QA_NAME } from '../RequestProfileTabAttachedRequests.constants'

import * as styles from './RequestProfileTabAttachedRequestsSubTabs.module.css'

function RequestProfileTabAttachedRequestsSubTabs({
  activeSubTab,
  counters,
  subMenu,
  onSetActiveSubTab,
}) {
  return (
    <EntityTabSubMenuSubTabs
      activeSubTab={activeSubTab}
      className={styles.subTabs}
      counters={counters}
      getCount={getEntityTabRequestsSubTabCount}
      qaName={REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_QA_NAME}
      subMenu={subMenu}
      onChange={onSetActiveSubTab}
    />
  )
}

export default RequestProfileTabAttachedRequestsSubTabs
